import { createFileRoute } from "@tanstack/react-router";
import DiagnosedDepressionAt70 from "@/pages/articles/DiagnosedDepressionAt70";
export const Route = createFileRoute("/diagnosed-with-depression-at-70")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Diagnosed With Depression At 70 | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Depression at 70 is often overlooked. Learn about TMS, SAINT TMS, and treatment options for older adults in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:title",
          content: "Diagnosed With Depression At 70 | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Depression at 70 is often overlooked. Learn about TMS, SAINT TMS, and treatment options for older adults in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/diagnosed-with-depression-at-70",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/diagnosed-with-depression-at-70",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <DiagnosedDepressionAt70 />;
}
